/// <reference path="../../../../../typings/index.d.ts" />

module Meevo.Components.Controls {

    import IDateRangeObject = Meevo.Components.Common.IDateRangeObject;
    import DateRangeService = Meevo.Components.Common.DateRangeService;
    import ComparedToEndChoicesEnum = Meevo.Components.Common.ComparedToEndChoicesEnum;


    interface ISelectedDateChoice {
        name: string;
        dates: IDateRangeObject;
        additionalControl?: string;
        comparedToEndChoices: (IComparedToDateChoice | IChoiceWithAdditionalControl)[];
    }

    const SELECTED_DATE_KEYS = {
        [ComparedToEndChoicesEnum.SpecificDate]: 'days',
        [ComparedToEndChoicesEnum.SpecificMonth]: 'months',
        [ComparedToEndChoicesEnum.SpecificYear]: 'years'
    };

    class RelativeComparisonPickerComponent implements angular.IComponentController {

        static $inject = ['meevo.components.common.DateRangeService'];

        public mainModel: Object;
        public parameterNames: string[];
        public securityAccess: any;
        public options: Object;

        public now: Date;
        public startOfThisMonth: Date;

        public comparedToStartChoices: ISelectedDateChoice[];

        public customYearList: number[];

        public compareToMaxDate: Date;
        public compareToMaxMonth: Date;
        public compareToMaxYear: number;

        private _selectedCustomStartDateModel: Date;
        private _selectedCustomEndDateModel: Date;
        private _selectedCustomMaxEndDateModel: Date;

        get selectedDate(): ISelectedDateChoice {
            return this._selectedDate;
        }

        set selectedDate(v: ISelectedDateChoice) {
            this._selectedDate = v;

            this.mainModel['SelectedStartDate'] = v.dates['from'];
            this.mainModel['SelectedEndDate'] = v.dates['to'];

            this.comparedToDate = v.comparedToEndChoices[0];
            this.mainModel['SelectedStartDateRange'] = v.name;

            if (v.additionalControl !== 'dateRangeSelector' &&
                this._selectedCustomStartDateModel > this._selectedCustomEndDateModel) {
                this._selectedCustomStartDateModel = this._selectedCustomEndDateModel;
            }

            this.updateValidationData();
        }

        get comparedToDate(): IComparedToDateChoice {
            return this._comparedToDate;
        }

        set comparedToDate(v: IComparedToDateChoice) {
            this._comparedToDate = v;
            this.mainModel['SelectedEndDateRange'] = v.name;

            this.updateComparedToValues();
        }

        get selectedCustomDateModel(): Date {
            return this._selectedCustomDateModel;
        }

        set selectedCustomDateModel(date: Date) {
            this._selectedCustomDateModel = date;

            this.mainModel['SelectedStartDate'] = moment(date).startOf('day').toDate();
            this.mainModel['SelectedEndDate'] = moment(date).endOf('day').toDate();

            this.updateComparedToValues();
            this.updateValidationData();
        }

        get selectedCustomStartDateModel(): Date {
            return this._selectedCustomStartDateModel;
        }

        set selectedCustomStartDateModel(date: Date) {
            this._selectedCustomStartDateModel = date;
            this._selectedCustomMaxEndDateModel = moment(date).add(1, 'years').toDate();
            
            this.mainModel['SelectedStartDate'] = date;

            this.updateComparedToValues();
            this.updateValidationData();
        }

        get selectedCustomEndDateModel(): Date {
            return this._selectedCustomEndDateModel;
        }

        set selectedCustomEndDateModel(date: Date) {
            this._selectedCustomEndDateModel = date;
            
            this.mainModel['SelectedEndDate'] = date;
            
            this.updateComparedToValues();
            this.updateValidationData();
        }

        get selectedCustomMaxEndDateModel(): Date {
            return this._selectedCustomMaxEndDateModel;
        }

        get comparedToCustomDateModel(): Date {
            return this._comparedToCustomDateModel;
        }

        set comparedToCustomDateModel(date: Date) {
            this._comparedToCustomDateModel = date;

            const { from, to } = (this.comparedToDate as IChoiceWithAdditionalControl).controlMapFn(date);

            this.mainModel['ComparedToStartDate'] = from;
            this.mainModel['ComparedToEndDate'] = to;

            this.updateComparedToComparedToValues();
        }

        get selectedCustomYear() {
            return this._selectedCustomYear;
        }

        set selectedCustomYear(year: number) {
            this._selectedCustomYear = year;

            const { from, to } = this.dateRangeService.thisYear(new Date(year, 1, 1));

            this.mainModel['SelectedStartDate'] = from;
            this.mainModel['SelectedEndDate'] = to;

            this.updateComparedToValues();
            this.updateValidationData();
        }

        get comparedCustomYear() {
            return this._comparedCustomYear;
        }

        set comparedCustomYear(year: number) {
            this._comparedCustomYear = year;

            const { from, to } = (this.comparedToDate as IChoiceWithAdditionalControl).controlMapFn(year);

            this.mainModel['ComparedToStartDate'] = from;
            this.mainModel['ComparedToEndDate'] = to;

            this.updateComparedToComparedToValues();
        }

        get selectedCustomMonthModel() {
            return this._selectedCustomMonthModel;
        }

        set selectedCustomMonthModel(date: Date) {
            this._selectedCustomMonthModel = date;

            const { from, to } = this.dateRangeService.thisMonth(date);

            this.mainModel['SelectedStartDate'] = from;
            this.mainModel['SelectedEndDate'] = to;

            this.updateComparedToValues();
            this.updateValidationData();
        }

        get comparedToCustomMonthModel() {
            return this._comparedToCustomMonthModel;
        }

        set comparedToCustomMonthModel(date: Date) {
            this._comparedToCustomMonthModel = date;

            const { from, to } = (this.comparedToDate as IChoiceWithAdditionalControl).controlMapFn(date);

            this.mainModel['ComparedToStartDate'] = from;
            this.mainModel['ComparedToEndDate'] = to;

            this.updateComparedToComparedToValues();
        }

        get isSpecificDateCompared(): boolean {
            return [
                ComparedToEndChoicesEnum.SpecificDate,
                ComparedToEndChoicesEnum.SpecificMonth,
                ComparedToEndChoicesEnum.SpecificYear
            ].indexOf(this.comparedToDate.id) !== -1;
        }

        get compareToYearList(): number[] {
            return _.range(1970, this.compareToMaxYear + 1);
        }


        private _selectedDate: ISelectedDateChoice;
        private _comparedToDate: IComparedToDateChoice;

        private _selectedCustomDateModel: Date;
        private _comparedToCustomDateModel: Date;

        private _selectedCustomMonthModel: Date;
        private _comparedToCustomMonthModel: Date;

        private _selectedCustomYear: number;
        private _comparedCustomYear: number;

        constructor(private dateRangeService: DateRangeService) {
        }

        public $onInit() {
            this.init();

            this.now = new Date();
            this.startOfThisMonth = moment().startOf('month').toDate();

            this.selectedDate = this.comparedToStartChoices[0];
            this.comparedToDate = this.comparedToStartChoices[0].comparedToEndChoices[0];

            this.customYearList = _.range(1970, 2050);

            this._selectedCustomDateModel = new Date();
            this._comparedToCustomDateModel = new Date();

            this._selectedCustomMonthModel = new Date();
            this._comparedToCustomMonthModel = new Date();

            this._comparedCustomYear = new Date().getFullYear();
            this._selectedCustomYear = new Date().getFullYear();
        }

        private updateComparedToValues(fromDate: Date = this.mainModel['SelectedStartDate'], toDate: Date = this.mainModel['SelectedEndDate']): void {
            let { from, to } = this.comparedToDate.callbackFn({ fromDate, toDate });

            this.mainModel['ComparedToStartDate'] = from;
            this.mainModel['ComparedToEndDate'] = to;

            this.updateComparedToComparedToValues();
        }

        private updateComparedToComparedToValues(): void {
            let { from, to } = this.comparedToDate.callbackFn({
                fromDate: this.mainModel['ComparedToStartDate'],
                toDate: this.mainModel['ComparedToEndDate'],
                selectedStartDate: this.mainModel['SelectedStartDate'],
                selectedEndDate: this.mainModel['SelectedEndDate']
            });

            if (this.isSpecificDateCompared) {
                let key = SELECTED_DATE_KEYS[this.comparedToDate.id];
                let startDaysDifference = moment(this.mainModel['ComparedToStartDate'])
                    .diff(this.mainModel['SelectedStartDate'], key);
                let endDaysDifference = moment(this.mainModel['ComparedToEndDate'])
                    .diff(this.mainModel['SelectedEndDate'], key);

                from = moment(this.mainModel['ComparedToStartDate'])
                    .add(startDaysDifference, key).startOf(key.slice(-1)).toDate();
                to = moment(this.mainModel['ComparedToEndDate'])
                    .add(endDaysDifference, key).endOf(key.slice(-1)).toDate();
            }

            this.mainModel['ComparedToComparedToStartDate'] = from;
            this.mainModel['ComparedToComparedToEndDate'] = to;
        }

        private updateValidationData() {
            this.compareToMaxDate = moment(this.mainModel['SelectedStartDate'])
                .add(-1, 'days').toDate();

            this.compareToMaxMonth = moment(this.mainModel['SelectedStartDate'])
                .add(-1, 'months').toDate();

            this.compareToMaxYear = (<Date>this.mainModel['SelectedStartDate']).getFullYear() - 1;
        }

        private init() {
            this.comparedToStartChoices = [
                {
                    name: 'Today',
                    dates: this.dateRangeService.today(),
                    comparedToEndChoices: [
                        new PreviousDayChoice(this.dateRangeService),
                        new SameDayPreviousMonthChoice(this.dateRangeService),
                        new SameDayPreviousWeekChoice(this.dateRangeService),
                        new SameDayPreviousYearChoice(this.dateRangeService),
                        new SpecificDateChoice(this.dateRangeService),
                    ]
                },
                {
                    name: 'Yesterday',
                    dates: this.dateRangeService.previousDay(),
                    comparedToEndChoices: [
                        new PreviousDayChoice(this.dateRangeService),
                        new SameDayPreviousMonthChoice(this.dateRangeService),
                        new SameDayPreviousWeekChoice(this.dateRangeService),
                        new SameDayPreviousYearChoice(this.dateRangeService),
                        new SpecificDateChoice(this.dateRangeService),
                    ]
                },
                {
                    name: 'Specific Date',
                    dates: this.dateRangeService.today(),
                    additionalControl: 'singleDateSelector',
                    comparedToEndChoices: [
                        new PreviousDayChoice(this.dateRangeService),
                        new SameDayPreviousMonthChoice(this.dateRangeService),
                        new SameDayPreviousWeekChoice(this.dateRangeService),
                        new SameDayPreviousYearChoice(this.dateRangeService),
                        new SpecificDateChoice(this.dateRangeService),
                    ]
                },
                {
                    name: 'This Week',
                    dates: this.dateRangeService.weekToDate(),
                    comparedToEndChoices: [
                        new PreviousWeekChoice(this.dateRangeService),
                        new SameWeekPreviousMonthChoice(this.dateRangeService),
                        new SameWeekPreviousYearChoice(this.dateRangeService),
                        new PreviousWeekToDateChoice(this.dateRangeService),
                        new SameWeekToDatePreviousMonthChoice(this.dateRangeService),
                        new SameWeekToDatePreviousYearChoice(this.dateRangeService)
                    ]
                },
                {
                    name: 'Last Week',
                    dates: this.dateRangeService.previousWeek(),
                    comparedToEndChoices: [
                        new PreviousWeekChoice(this.dateRangeService),
                        new SameWeekPreviousMonthChoice(this.dateRangeService),
                        new SameWeekPreviousYearChoice(this.dateRangeService)
                    ]
                },
                {
                    name: 'This Month',
                    dates: this.dateRangeService.monthToDate(),
                    comparedToEndChoices: [
                        new PreviousMonthChoice(this.dateRangeService),
                        new SameMonthPreviousYearChoice(this.dateRangeService),
                        new SpecificMonthChoice(this.dateRangeService),
                        new PreviousMonthToDateChoice(this.dateRangeService),
                        new SameMonthToDatePreviousYearChoice(this.dateRangeService),
                        new SpecificMonthToDateChoice(this.dateRangeService)
                    ]
                },
                {
                    name: 'Last Month',
                    dates: this.dateRangeService.previousMonth(),
                    comparedToEndChoices: [
                        new PreviousMonthChoice(this.dateRangeService),
                        new SameMonthPreviousYearChoice(this.dateRangeService),
                        new SpecificMonthChoice(this.dateRangeService)
                    ]
                },
                {
                    name: 'Specific Month',
                    dates: this.dateRangeService.thisMonth(),
                    additionalControl: 'singleMonthSelector',
                    comparedToEndChoices: [
                        new PreviousMonthChoice(this.dateRangeService),
                        new SameMonthPreviousYearChoice(this.dateRangeService),
                        new SpecificMonthChoice(this.dateRangeService)
                    ]
                },
                {
                    name: 'This Quarter',
                    dates: this.dateRangeService.quarterToDate(),
                    comparedToEndChoices: [
                        new PreviousQuarterChoice(this.dateRangeService),
                        new SameQuarterPreviousYearChoice(this.dateRangeService),
                        new PreviousQuarterToDateChoice(this.dateRangeService),
                        new SameQuarterToDatePreviousYearChoice(this.dateRangeService)
                    ]
                },
                {
                    name: 'Last Quarter',
                    dates: this.dateRangeService.getQuarter(true),
                    comparedToEndChoices: [
                        new PreviousQuarterChoice(this.dateRangeService),
                        new SameQuarterPreviousYearChoice(this.dateRangeService)
                    ]
                },
                {
                    name: 'This Year',
                    dates: this.dateRangeService.thisYearToDate(),
                    comparedToEndChoices: [
                        new PreviousYearChoice(this.dateRangeService),
                        new SpecificYearChoice(this.dateRangeService),
                        new PreviousYearToDateChoice(this.dateRangeService),
                        new SpecificYearToDateChoice(this.dateRangeService)
                    ]
                },
                {
                    name: 'Last Year',
                    dates: this.dateRangeService.previousYear(),
                    comparedToEndChoices: [
                        new PreviousYearChoice(this.dateRangeService),
                        new SpecificYearChoice(this.dateRangeService)
                    ]
                },
                {
                    name: 'Specific Year',
                    dates: this.dateRangeService.thisYear(),
                    additionalControl: 'singleYearSelector',
                    comparedToEndChoices: [
                        new PreviousYearChoice(this.dateRangeService),
                        new SpecificYearChoice(this.dateRangeService)
                    ]
                },
				//(Start) Here are my changes.............................................
				{
					name: 'Specific Date Range',
					dates: this.dateRangeService.today(),
					additionalControl: 'dateRangeSelector',
					comparedToEndChoices: [
                        new SameDateRangePreviousYearChoice(this.dateRangeService),
					]
				},
				//(End) Here are my changes.............................................
            ];
        }
    }


    angular.module('meevo.components.controls')
        .component('meevoRelativeComparisonPickerComponent', <angular.IComponentOptions>{
            templateUrl: 'app/components/controls/relative-comparison-picker/relative-comparison-picker.component.html',
            controller: RelativeComparisonPickerComponent,
            controllerAs: '$ctrl',
            bindings: {
                mainModel: '<',
                parameterNames: '<',
                securityAccess: '<',
                options: '<',
            }
        });
}
